"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getRemoveFromCartTemplate = function getRemoveFromCartTemplate() {
  return {
    productListRemovals: {
      value: 1
    }
  };
};
var _default = exports["default"] = getRemoveFromCartTemplate;